import {
    Box,
    styled,
    $error,
    $fontSize,
} from '@acko-tech/building-blocks.ui.common';

export const StyledBox = styled(Box)``;

export const ErrorText = styled.p`
    margin: 0;
    font-size: 11px;
    color: ${$error};
    white-space: pre-wrap;
    margin-bottom: 1em;
`;

export const FuelOptionsText = styled.p`
    width: 100%;
    margin: 0;
    font-size: ${$fontSize.xs};
    line-height: 22px;
    color: #040222;
`;

export const FuelTextContainer = styled(Box)`
    padding: 1rem 0;
    cursor: pointer;
    :not(:last-child) {
        border-bottom: 1px solid #dcdce0;
    }
    :first-child {
        padding-top: 4px;
    }
`;

export const AddonModalRow = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 1rem 0;
    border-bottom: 1px solid #dcdce0;
    &:first-child {
        padding-top: 4px;
    }
    &:last-child {
        border-bottom: none;
    }
`;

export const AddonModalRowMain = styled(Box)`
    flex: 1;
    min-width: 0;
`;

export const AddonRowAction = styled.button`
    background: none;
    border: none;
    padding: 4px 0;
    margin: 0;
    font-size: 12px;
    line-height: 22px;
    color: #2563eb;
    cursor: pointer;
    text-decoration: underline;
    flex-shrink: 0;
    font-weight: 500;

    &[data-variant='danger'] {
        color: #e11d48;
    }

    &:disabled {
        color: #9ca3af;
        cursor: not-allowed;
        text-decoration: none;
    }
`;

export const SelectedAddonsWrap = styled(Box)`
    margin-top: 0.75rem;
    padding: 0 2px;
`;

export const SelectedAddonLine = styled(Box)`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 12px;
    padding: 10px 0;
    border-bottom: 1px solid #ececf0;
    &:last-child {
        border-bottom: none;
    }
`;

export const SelectedAddonName = styled.p`
    margin: 0;
    font-size: ${$fontSize.xs};
    line-height: 22px;
    color: #040222;
    font-weight: 500;
`;

export const SelectedAddonMeta = styled.p`
    margin: 2px 0 0;
    font-size: 12px;
    line-height: 18px;
    color: #5c5c6e;
`;

export const PremiumBreakdownBox = styled(Box)`
    margin-top: 1rem;
    padding: 14px 16px;
    border-radius: 8px;
    background: #f7f7f9;
    border: 1px solid #ececf0;
`;

export const PremiumBreakdownRow = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: ${$fontSize.xs};
    line-height: 22px;
    color: #040222;
    &:not(:last-child) {
        margin-bottom: 8px;
    }
`;

export const PremiumBreakdownTotal = styled(PremiumBreakdownRow)`
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #dcdce0;
    font-weight: 600;
`;
